<template>
  <div class="active-static-tab-content-wrap" v-if="activeType.value">
    <div class="active-static-tab-content-total">

      <div class="active-static-tab-content-total-num" :class="activeType == 'teacher'
          ? 'active-static-tab-content-total-num-diff-top'
          : ''
        ">
        <div class="inter-count">
          <img src="../../../assets/images/databoard/inter-cirle-one-small.png" width="100%" height="100%"
            class="big-img" />
          <div class="cirle-small">
            <img src="../../../assets/images/databoard/inter-cirle-two-small.png" width="100%" height="100%"
              class="small-img" />
            <div class="count">
              <span class="num" style="display: flex;justify-content: center; align-items: center;height: 40px;">
                <count-up class="infor-card-count user-created-count" :id-name="`${activeType.id[0]}${tabCode}TotalNum`"
                  :end-val=" activeType.value[0] " color="#0EFCFF" countSize="24" :countWeight="countWeight">
                </count-up>
                <div style="font-size: 10px;margin-left: 4px;"> 次</div>
              </span>
            </div>
          </div>
        </div>
        <div style="color: #0efcff;font-size: 16px;">{{ activeType.data[0] }}</div>
      </div>

    </div>

    <div class="active-static-tab-content-total">

      <div class="active-static-tab-content-total-num" :class="activeType == 'teacher'
          ? 'active-static-tab-content-total-num-diff-top'
          : ''
        ">
        <div class="inter-count">
          <img src="../../../assets/images/databoard/inter-cirle-one-small.png" width="100%" height="100%"
            class="big-img" />
          <div class="cirle-small">
            <img src="../../../assets/images/databoard/inter-cirle-two-small.png" width="100%" height="100%"
              class="small-img" />
            <div class="count">
              <span class="num" style="display: flex;justify-content: center; align-items: center;height: 40px;">
                <count-up class="infor-card-count user-created-count" :id-name="`${activeType.id[1]}${tabCode}TotalNum`"
                  :end-val=" activeType.value[1] " color="#0EFCFF" countSize="24" :countWeight="countWeight">
                </count-up>
                <div style="font-size: 10px;margin-left: 4px;"> 次</div>
              </span>
            </div>
          </div>
        </div>
        <div style="color: #0efcff;font-size: 16px;">{{ activeType.data[1] }}</div>
      </div>

    </div>
    <div class="active-static-tab-content-total">

      <div class="active-static-tab-content-total-num" :class="activeType == 'teacher'
          ? 'active-static-tab-content-total-num-diff-top'
          : ''
        ">
        <div class="inter-count">
          <img src="../../../assets/images/databoard/inter-cirle-one-small.png" width="100%" height="100%"
            class="big-img" />
          <div class="cirle-small">
            <img src="../../../assets/images/databoard/inter-cirle-two-small.png" width="100%" height="100%"
              class="small-img" />
            <div class="count">
              <span class="num" style="display: flex;justify-content: center; align-items: center;height: 40px;">
                <count-up class="infor-card-count user-created-count" :id-name="`${activeType.id[2]}${tabCode}TotalNum`"
                  :end-val=" activeType.value[2] " color="#0EFCFF" countSize="24" :countWeight="countWeight">
                </count-up>
                <div style="font-size: 10px;margin-left: 4px;"> 次</div>
              </span>
            </div>
          </div>
        </div>
        <div style="color: #0efcff;font-size: 16px;">{{ activeType.data[2] }}</div>
      </div>

    </div>
  </div>
</template>

<script>
import Vue from "vue";
import CountUp from "../../../components/countUp.vue";

export default {
  name: "active-content",
  data() {
    return {
      countWeight: 400,
      rankingLocalList: [],
      curStaticLocalData: {
        hwCorrectRate: 0,
      }, //当前年级活跃下的统计数据
      subjectId: "",
      gradeId: "",
    };
  },
  components: {
    CountUp,
  },
  props: {
    activeType: String,
  },
  watch: {
    rankingList: "initRankingList",
  },
  methods: {
  },
  mounted() { },
};
</script>

<style lang="scss" scoped>
@import "../../../style/databoard";
@import "../../../style/layout";

.active-static-tab-content-ranking-split-line {
  background-image: url("../../../assets/images/databoard/active-icon.png");
}

.active-static-tab-content-ranking-item:nth-child(-n + 0) {
  .active-static-tab-content-ranking-item-num {
    color: #0efcff !important;
  }
}

.active-static-tab-content-total-list {
  display: flex;
  justify-content: center;
}
</style>

<style lang="scss">
.active-static-tab-content-total-sel-box {
  display: flex;

  .ivu-select {
    /*width: 93px !important;*/
    padding-right: 5px;
    text-align: center;
    color: #0efcff !important;
  }

  .ivu-select-selection {
    height: 26px !important;
    background: rgba(14, 252, 255, 0.05) !important;
    box-shadow: inset 0px 0px 10px 4px rgba(14, 252, 255, 0.15) !important;
    border-radius: 13px !important;
    border: unset !important;
  }

  .ivu-select-single .ivu-select-selection .ivu-select-placeholder {
    color: #0efcff !important;
  }

  .ivu-select-arrow {
    color: #0efcff !important;
  }

  .ivu-select-single .ivu-select-selection .ivu-select-placeholder,
  .ivu-select-single .ivu-select-selection .ivu-select-selected-value {
    height: 26px !important;
    line-height: 26px !important;
  }

  .ivu-select-dropdown {
    max-height: 95px;
    background: rgba(10, 18, 39, 0.97);
    box-shadow: inset 0px 0px 10px 4px rgba(14, 252, 255, 0.15) !important;
    border-radius: 5px;
  }

  .ivu-select-item {
    color: #0efcff !important;
  }

  .ivu-select-item:hover {
    background: #0efcff !important;
    color: #0a1227 !important;
  }

  .ivu-select-item-focus {
    background: #0efcff !important;
    color: #0a1227 !important;
  }
}
</style>
